import { createContext, useContext } from "react";
export function createUseContext(defaultCurrent) {
  var Context = /*#__PURE__*/createContext(defaultCurrent);
  function useToContext() {
    return useContext(Context);
  }
  return [Context.Provider, useToContext];
}